/**
 * Created by Ning Jiang on 2024-01-19.
 */

import {TimelineLite} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ElGordosRevengeSymbol} from "./ElGordosRevengeSymbol";
import {ElGordosRevengeSymbolState} from "./ElGordosRevengeSymbolConfig";
import {MultiSprites} from "@nolimitcity/slot-game/bin/animation/MultiSprites";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {ElGordosRevengeLayers, Layers} from "../view/ElGordosRevengeLayers";
import {ElGordosRevenge} from "../ElGordosRevenge";

export class EGRReelSplitSymbol extends ElGordosRevengeSymbol {

    constructor(reelId:number, initState:ElGordosRevengeSymbolState) {
        super("WRS", reelId, initState);
    }

    // public split(type:number, noWin:boolean):TimelineLite {
    //     return new TimelineLite();
    // }

    public playOnShot():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I play on shot!`);
        });
        return tl;
    }

    protected getOnShotAnimationName():string {
        return `WRS_Shoot`;
    }

    protected getDeadLoopAnimationName():string {
        return `WRS_DeadLoop`;
    }

    protected getCharacterAssetName():string {
        return "WRS";
    }

    public playLanding(init:boolean = false):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(0, "WRS_Landing", false);
        });

        tl.add(() => {
            this._deadCharacter.visible = false;
        }, `+=${this._deadCharacter.spineData.findAnimation("WRS_Landing").duration}`);
        tl.add(this.showWild(false), `-=0.2`);
        return tl;
    }

    protected addSplitPartOverlay(part:MultiSprites):TimelineLite {
        return this.addWildToPart(part, false);
    }

    // protected playKill():TimelineLite {
    //     this.createDeadContainer();
    //     const tl = new TimelineLite();
    //     const aniName = this.getKillAnimationName();
    //     tl.add(() => {
    //         this._deadCharacter.visible = true;
    //         this._deadCharacter.state.setAnimation(0, aniName, false);
    //         this.playKillSound();
    //     });
    //     tl.add(() => {
    //         if(this.removed) {
    //             return;
    //         }
    //         if(this._parts[0].currentSpriteName === ElGordosRevengeSymbolState.NORMAL) {
    //         } else {
    //             this.getStateColorChangeAnimation();
    //         }
    //         this._deadCharacter.visible = false;
    //     }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);
    //     return tl;
    // }

    // public playIndividualKill():TimelineLite {
    //     this.createDeadContainer();
    //     const tl = new TimelineLite();
    //     const aniName = this.getIndividualAnimationName();
    //     tl.add(() => {
    //         if(!this.removed) {
    //             this._deadCharacter.visible = true;
    //             this._deadCharacter.state.setAnimation(0, aniName, false);
    //         }
    //     });
    //     tl.add(() => {
    //         if(!this.removed) {
    //             this._deadCharacter.visible = false;
    //         }
    //     }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);
    //     return tl;
    // }

    protected playKillSound():void {
        ElGordosRevengeSound.playSymbolKill("WRS", this.reelId);
    }

    public split(type:number, noWin:boolean):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        const aniName = "WRS_Split";
        const position = new PIXI.Point(this.position.x, this.position.y);
        const globalPosition = this.getGlobalCenterPosition();
        tl.add(
            () => {
                this.position.set(globalPosition.x, globalPosition.y);
                ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChildAt(this, 0);
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(0, aniName, false);
                // this.playKillSound();
            });
        tl.add(() => {
            // this._deadCharacter.visible = false;
            this.position.set(position.x, position.y);
            ElGordosRevenge.reels[this.reelId].reelView.addWinSymbol(this);
        }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);
        tl.add(super.split(type, noWin));
        return tl;
    }
}